import { render, staticRenderFns } from "./HotOfferIcon.vue?vue&type=template&id=ff2f7a40&scoped=true"
import script from "./HotOfferIcon.vue?vue&type=script&lang=js"
export * from "./HotOfferIcon.vue?vue&type=script&lang=js"
import style0 from "./HotOfferIcon.vue?vue&type=style&index=0&id=ff2f7a40&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ff2f7a40",
  null
  
)

export default component.exports